module.exports = __webpack_public_path__ + "static/bursatilidad-8383d4cefd24d02338e70b0c344eeb16.jpg";